<template>
  <div class="dialog" v-show="showMask">
    <div class="dialog-container">
      <div class="dialog-title">
        <div class="dialog-title-text left-content">
          <span class="dialog-title-text-span" style="line-height: 38px"
            >{{this.$root.htmlConst.cons_335_acw_dialog_title}}</span
          >
          <span class="dialog-issue-number">{{ "#" + issueNumber }}</span>
        </div>
        <div class="dialog-input">
          <div class="dialog-title-input">
            <el-input
              v-model="search"
              :placeholder="$root.htmlConstRecording.cons_301_dialog_input_text"
              clearable
              @keyup.enter.native="handleEnterKey"
            ></el-input>
          </div>
          <el-button
            v-if="multipleSelection.length"
            type="info"
            @click="upSelect"
            icon="el-icon-caret-top"
            size="mini"
            class="search-nav-btn gray-button"
            style="margin-left: 1%"
          ></el-button>
          <el-button
            v-else
            type="info"
            @click="upSelect"
            icon="el-icon-caret-top"
            size="mini"
            class="search-nav-btn gray-button"
            style="margin-left: 1%"
            disabled
          ></el-button>
          <span
            v-if="search != '' && multipleSelection.length"
            style="padding: 0 4px; color: white; line-height: 40px"
            >{{ searchIndex }}/{{ multipleSelection.length }}</span
          >
          <span
            v-else-if="search != '' && multipleSelection.length == 0"
            style="padding: 0 4px; color: white; line-height: 40px"
            >0/0</span
          >
          <span
            v-else
            style="padding: 0 4px; color: white; line-height: 40px"
            >0/0</span
          >
          <el-button
            v-if="multipleSelection.length"
            type="info"
            @click="downSelect"
            icon="el-icon-caret-bottom"
            size="mini"
            class="search-nav-btn gray-button"
          ></el-button>
          <el-button
            v-else
            type="info"
            @click="downSelect"
            icon="el-icon-caret-bottom"
            size="mini"
            class="search-nav-btn gray-button"
            disabled
          ></el-button>
        </div>
        <div class="dialog-title-close">
          <img
            src="../../assets/img/close.png"
            style="margin-top: 3px; cursor: pointer"
            @click="closeMask()"
          />
        </div>
      </div>
      <div class="dialog-content">
        <div class="dialog-left-content left-content">
          <!-- Category Part Start-->
          <!-- 2026-03-13 move the category part to the top -->
          <div class="dialog-category-div">
            <div class="dialog-category-title" @click="toggleCategory">
              <span class="dialog-category-title-span">{{
                $root.htmlConstRecording.cons_302_dialog_category_text
              }}</span>
              <i
                :class="
                  showCategory ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </div>
            <div class="dialog-category" v-if="showCategory">
              <div
                v-for="tag in categoryTagArr"
                :key="tag.name"
                :type="tag.type"
              >
                <span class ="category left-content-small-text">{{ tag.name }}</span>
              </div>
            </div>
          </div>
          <!-- Category Part End-->
          <el-divider content-position="center"></el-divider>
          <!-- Support time part start -->
          <div class="support-time">
            <div
              class="support-time-title left-div-title"
              @click="toggleSupportTime"
            >
              <span>サポート時間</span>
              <i
                :class="
                  showSupportTime ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </div>
            <div class="support-time-content" v-if="showSupportTime">
              <div class="support-time-date left-content-small-text">
                {{ supportDate }}
              </div>
              <div class="support-time-time left-content-small-text">
                {{ "開始：" + startTime + "　〜　終了：" + endTime + callTime }}
              </div>
            </div>
          </div>
          <!-- Support time part End -->
          <el-divider content-position="center"></el-divider>
          <!-- Alert info part start -->
          <div class="detected-alerts-div">
            <div
              class="detected-alerts-title left-div-title"
              @click="toggleAlerts"
            >
              <span class="detected-alerts-title-span">{{$root.htmlConst.cons_152_table_header_alert}}（登場回数）</span>
              <i
                :class="showAlerts ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></i>
            </div>
            <div class="detected-alerts" v-if="showAlerts">
              <!-- <el-tag><span class="alert-sv el-tag-common">SVヘルプ (1)</span></el-tag> -->
              <el-tag key="warning" v-if="alertInfo.warningCount > 0 ">
                <span class="alert-warning-tag el-tag-common">{{ `要注意 (${alertInfo.warningCount})`}}</span>
              </el-tag>
              <el-tag key="longTime" v-if="alertInfo.longTimeFlg ==='true' ">
                <span class="alert-long-time el-tag-common">長時間</span>
              </el-tag>
              <el-tag Key="ng" v-if="alertInfo.ngCount > 0 ">
                <span class="alert-ng el-tag-common">{{ `NG (${alertInfo.ngCount})` }}</span>
              </el-tag>
            </div>
          </div>
          <!-- Alert info part End -->
          <el-divider content-position="center"></el-divider>
          <!-- Escalation info part Start -->
          <div class="escalation-div">
            <div
              class="escalation-title left-div-title"
              @click="toggleEscalation"
            >
              <span class="escalation-title-span">エスカレーション</span>
              <i
                :class="
                  showEscalation ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </div>
            <div class="escalation-content" v-if="showEscalation">
              <div class="escalation-result left-content-small-text">なし</div>
            </div>
          </div>
          <!-- Escalation info part End -->
          <!-- Score info part Start -->
          <!-- -->
          <div class="score-div" v-if="false">
            <div class="score-title left-div-title">
              <span class="score-title-span">応対スコア</span>
            </div>
            <div class="score-content">
              <span class="score-questioner left-content-small-text"
                >お問い合わせ者の評価</span
              >
              <el-rate
                :value="0"
                disabled
                disabled-void-color="#c6d1de"
                disabled-void-icon-class="el-icon-star-off"
              >
              </el-rate>
            </div>
            <div class="score-content">
              <span class="score-questioner left-content-small-text"
                >SVの評価</span
              >
              <el-rate
                :value="0"
                disabled
                disabled-void-color="#c6d1de"
                disabled-void-icon-class="el-icon-star-off"
              >
              </el-rate>
            </div>
          </div>
           <!-- Score info part End -->
          <el-divider content-position="center"></el-divider>
          <div class="dialog-ng-div">
            <div class="dialog-category-title" @click="toggleNgcontent">
              <span class="dialog-category-title-span">{{
                $root.htmlConstRecording.cons_303_dialog_content_text
              }}</span>
              <i :class="showNgcontent ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div class="dialog-ngcontent" v-if="showNgcontent">
              <!-- <el-scrollbar style="height:100%;overflow-y: auto;overflow-x: hidden;"> -->
              <!-- <el-tag v-for="tag in ngArr" :key="tag.name" :type="tag.type"> {{tag.name}}</el-tag> -->
              <el-tag v-for="(tag,index) in ngArr" :key="index+1" :type="tag.type">
                <span
                  v-if="tag.type === 'warningWordType'"
                  class="warningWordType el-tag-common"
                  >{{ tag.name }}</span
                >
                <span
                  v-if="tag.type === 'ngwordOType'"
                  class="ngwordOType el-tag-common"
                  >{{ tag.name }}</span
                >
                <span
                  v-else-if="tag.type === 'ngwordQType'"
                  class="ngwordQType el-tag-common"
                  >{{ tag.name }}</span
                >
                <span
                  v-else-if="tag.type === 'ngMannerType'"
                  class="ngMannerType el-tag-common"
                  >{{ tag.name }}</span
                >
                <span
                  v-else-if="tag.type === 'ngWowType'"
                  class="ngWowType el-tag-common"
                  >{{ tag.name }}</span
                >
              </el-tag>
              <!-- </el-scrollbar> -->
            </div>
          </div>
          <el-divider content-position="center"></el-divider>
          <!-- ACW content part start -->
          <div class="acw-content">
            <div
              class="acw-content-title left-div-title"
              @click="toggleAcwContent"
            >
              <span>{{ $root.htmlConst.cons_332_table_header_acw_content }}</span>
              <i
                :class="showAcwContent ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></i>
            </div>
            <div class="acw-content-body" v-if="showAcwContent">
              <div class="detected-alerts">
                <el-tag key="acw-content" v-if="dialogAcwContent.length > 0">
                  <span class="alert-acw-content el-tag-common">{{ dialogAcwContent }}</span>
                </el-tag>
              </div>
            </div>
          </div>
          <!-- ACW content part End -->
          <!-- <el-divider content-position="center"></el-divider> -->
        </div>
        <div class="dialog-right-content">
          <div class="user-info">
            <el-avatar
              class="from-user-image user-info-margin-left"
              :src="callInfo.fromLogoUrl"
            ></el-avatar>
            <span class="from-user-name user-info-margin-left">{{
              callInfo.fromUsername + "（" + callInfo.fromPhoneNum + "）"
            }}</span>
            <span class="from-phone-number">と</span>
            <el-avatar
              class="to-user-image user-info-margin-left"
              :src="callInfo.toLogoUrl"
            ></el-avatar>
            <span class="from-phone-number user-info-margin-left">{{
              callInfo.toUsername +
              (isVoiceBot ? "" : "（" + callInfo.toPhoneNum + "）") +
              " の通話"
            }}</span>
            <span class="user-info-margin-left" v-if="!isVoiceBot"
              >{{
                callInfo.callType === "IN"
                  ? "（インバウンド）"
                  : callInfo.callType === "OUT"
                  ? "(アウトバウンド)"
                  : ""
              }}
            </span>
          </div>
          <div class="content-title">
            <div class="content-subject">
              {{ $root.htmlConstRecording.cons_307_table_subject }}
            </div>
            <div class="content-title-text">{{ title }}</div>
          </div>
          <div class="wav-content">
            <div v-if="false" class="wav-image-box">
              <div class="wav-title">音声</div>
              <div class="wav-image">
                <!-- <el-avatar class="wav-from-avatar" :src="callInfo.fromLogoUrl"></el-avatar> -->
                <span class="wav-from-avatar">
                  {{ callInfo.fromUsername }}
                </span>
                <img
                  height="100%"
                  width="100%"
                  src="../../assets/img/wav-image.png"
                />
                <span class="wav-to-avatar"> {{ callInfo.toUsername }} </span>
                <!-- <el-avatar class="wav-to-avatar" :src="callInfo.toLogoUrl"></el-avatar> -->
              </div>
            </div>
            <div class="wav-script-box">
              <div class="wav-script-title">全文テキスト</div>
              <div class="backgroundDiv script-content-height">
                <el-table
                  :data="contenttextList"
                  height="100%"
                  ref="multipleTextTable"
                  :show-header="false"
                >
                  <template slot="empty">
                    <p>{{ emptyText }}</p>
                  </template>
                  <el-table-column>
                    <template slot-scope="scope">
                      <div
                        v-for="(text, idx) in scope.row.text.split(
                          '\n--------\n'
                        )"
                        :key="idx"
                      >
                        <Sentence
                          v-if="text.length > 0"
                          :textObject="handleContent(text)"
                        ></Sentence>
                        <!-- 
									<div style="text-align: left" v-html="text.replace('\n', '<br/>')"></div> -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div
                class="categoryDiv script-content-height"
                v-show="categoryList !== undefined && categoryList.length > 0"
              >
                <el-table
                  :data="categoryList"
                  height="100%"
                  ref="categoryTable"
                  :show-header="false"
                >
                  <el-table-column>
                    <template slot-scope="scope">
                      <div
                        v-for="(text, idx) in scope.row.text.split(
                          '\n--------\n'
                        )"
                        :key="idx"
                      >
                        <Sentence
                          v-if="text.length > 0"
                          :textObject="handleContent(text)"
                        ></Sentence>
                        <!-- <div style="text-align: left" v-html="text.replace('\n', '<br/>')"></div> -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div
                class="mannersDiv script-content-height"
                v-show="mannersList !== undefined && mannersList.length > 0"
              >
                <el-table
                  :data="mannersList"
                  height="100%"
                  ref="mannerTable"
                  :show-header="false"
                >
                  <el-table-column>
                    <template slot-scope="scope">
                      <div
                        v-for="(text, idx) in scope.row.text.split(
                          '\n--------\n'
                        )"
                        :key="idx"
                      >
                        <!-- <div style="text-align: left" v-html="text.replace('\n', '<br/>')"></div> -->
                        <Sentence
                          v-if="text.length > 0"
                          :textObject="handleContent(text)"
                        ></Sentence>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div
                class="wowDiv script-content-height"
                v-show="wowList !== undefined && wowList.length > 0"
              >
                <el-table
                  :data="wowList"
                  height="100%"
                  ref="wowTable"
                  :show-header="false"
                >
                  <el-table-column>
                    <template slot-scope="scope">
                      <div
                        v-for="(text, idx) in scope.row.text.split(
                          '\n--------\n'
                        )"
                        :key="idx"
                      >
                        <Sentence
                          v-if="text.length > 0"
                          :textObject="handleContent(text)"
                        ></Sentence>
                        <!-- <div style="text-align: left" v-html="text.replace('\n', '<br/>')"></div> -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div
                class="ngWordDiv script-content-height"
                v-show="ngWordList !== undefined && ngWordList.length > 0"
              >
                <el-table
                  :data="ngWordList"
                  height="100%"
                  ref="ngWordTable"
                  :show-header="false"
                >
                  <el-table-column>
                    <template slot-scope="scope">
                      <div
                        v-for="(text, idx) in scope.row.text.split(
                          '\n--------\n'
                        )"
                        :key="idx"
                      >
                        <!-- <div style="text-align: left" v-html="text.replace('\n', '<br/>')"></div> -->
                        <Sentence
                          v-if="text.length > 0"
                          :textObject="handleContent(text)"
                        ></Sentence>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="wav-script-box-ai">
              <div class="wav-title">{{ this.$root.htmlConst.cons_329_gpt_summary}}</div>
              <div class="backgroundDiv script-content-height">
                <div
                  ref="aiSummaryContent"
                  class="script-content-ai"
                  v-html="aiSummaryDisplay"
                ></div>
              </div>
            </div>
            <!-- Next Action（次のアクション）: read-only ACW content -->
            <div class="wav-script-box-next">
              <div class="wav-title">{{ this.$root.htmlConst.cons_334_gpt_next_action}}</div>
              <div class="backgroundDiv script-content-height">
                <div class="script-content-next">
                  <!-- Render numbered next actions as an indented list when Dify returns list-style text. -->
                  <ol v-if="nextActionItems.length" class="next-action-list">
                    <li v-for="(item, index) in nextActionItems" :key="index">
                      {{ item }}
                    </li>
                  </ol>
                  <div v-else>{{ nextActionContent }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <audio
          src=""
          ref="audioPlayer"
          id="audioPlayer"
          preload="auto"
          type="audio/wav"
          controls="controls"
          style="display: none"
        >
          {{ $root.htmlConstRecording.cons_304_dialog_message_text }}
        </audio>
        <div class="left-content"></div>
        <div class="audio-container">
          <div class="audio-control">
            <div class="audio-control-top">
              <span class="audio-time">{{ audioCurrentTime }}</span>
              <div class="audio-control-top-play">
                <img
                  src="../../assets/img/fast-rewind-48.png"
                  :class="['audio-control-button', { 'audio-control-button-disabled': !audioPlayable }]"
                  style="margin-left: 12px"
                  @click="rewind()"
                />
                <img
                  src="../../assets/img/play-arrow-48.png"
                  v-show="!play"
                  :class="['audio-control-button', { 'audio-control-button-disabled': !audioPlayable }]"
                  style="margin-left: 20px; margin-right: 20px"
                  @click="doPlay(true)"
                />
                <img
                  src="../../assets/img/pause-48.png"
                  v-show="play"
                  :class="['audio-control-button', { 'audio-control-button-disabled': !audioPlayable }]"
                  style="margin-left: 20px; margin-right: 20px"
                  @click="doPlay(false)"
                />
                <img
                  src="../../assets/img/fast-forward-48.png"
                  :class="['audio-control-button', { 'audio-control-button-disabled': !audioPlayable }]"
                  @click="forward()"
                />
              </div>
              <span class="audio-time">{{ audioAllTime }}</span>
            </div>
            <div class="audio-control-bottom">
              <el-slider
                v-model="audioTime"
                class="play-slider"
                :disabled="!audioPlayable"
                @change="onTimeChange"
              ></el-slider>
            </div>
          </div>
          <div class="audio-control-top-speed">
            <el-dropdown
              trigger="click"
              class="audio-speed-dropdown"
              @command="handleCommand"
            >
              <span class="dropdown-link">X {{ multipleIndex }}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0.75">X 0.75</el-dropdown-item>
                <el-dropdown-item command="1">X 1.0</el-dropdown-item>
                <el-dropdown-item command="1.25">X 1.25</el-dropdown-item>
                <el-dropdown-item command="1.5">X 1.5</el-dropdown-item>
                <el-dropdown-item command="2.0">X 2.0</el-dropdown-item>
                <el-dropdown-item command="2.5">X 2.5</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="audio-volume">
            <img
              src="../../assets/img/volume-up-32.png"
              v-show="volumeCV"
              style="margin: 22px 10px; cursor: pointer; float: left"
              @click="volumeControl(false)"
            />
            <img
              src="../../assets/img/volume-off-32.png"
              v-show="!volumeCV"
              style="margin: 22px 10px; cursor: pointer; float: left"
              @click="volumeControl(true)"
            />
            <el-slider
              v-model="volumeValue"
              class="volume-slider"
              @change="onVolumeChange"
            ></el-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { find } from "lodash";
import moment from "moment-timezone";
import Sentence from "./Sentence.vue";
let audioInterval;
export default {
  components: { Sentence },
  props: {
    value: {},
    title: {
      type: String,
      default: "",
    },
    issueNumber: {
      type: String,
      default: "",
    },
    callInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    categoryList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    mannersList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    wowList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    ngWordList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    contenttextList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    ngArr: {
      type: Array,
      default: function () {
        return [];
      },
    },
    categoryTagArr: {
      type: Array,
      default: function () {
        return [];
      },
    },
    dialogAiContent: {
      type: String,
      default: "",
    },
    /** Next Action（次のアクション）表示用の読み取り専用テキスト（ACW内容） */
    nextActionContent: {
      type: String,
      default: "",
    },
    /** ACW内容: read-only ACW content shown on the left side (mirrors the table's ACW内容 column) */
    dialogAcwContent: {
      type: String,
      default: "",
    },
    alertInfo:{
      type: Object,
      default: function () {
        return {};
      },
    }
  },
  data() {
    return {
      showMask: false,
      play: false,
      multipleIndex: 1,
      sliderTime: 0,
      volumeCV: true,
      volumeValue: 0,
      volumeValueBack: 0,
      audioTime: 0,
      audioCurrentTime: "00:00",
      audioAllTime: "00:00",
      audioAllDuration: 0,
      audioPlayable: false,
      search: "",
      oldSearch: "",
      searchIndex: 0,
      multipleSelection: [],
      arrowFlg: false,
      emptyText: "",
      defaultProfile:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      showSupportTime: true,
      showAcwContent: true,
      showCategory: true,
      showNgcontent: true,
      showAlerts: true,
      showEscalation: true,
      contenttextListPage: [],
      /** 要約（summary）表示。検索ハイライト用に prop の dialogAiContent と分離 */
      aiSummaryDisplay: "",
    };
  },
  methods: {
    closeMask() {
      this.$refs.audioPlayer.pause();
      this.showMask = false;
    },
    setAudioInterval() {
      audioInterval = setInterval(() => {
        this.getAudioTime();
        let audioPlayer = document.getElementById("audioPlayer");
        if (audioPlayer.ended) {
          clearInterval(audioInterval);
          this.audioTime = 0;
          audioPlayer.currentTime = 0;
          this.audioCurrentTime = "00:00";
          this.audioAllTime = "00:00";
          this.play = false;
        }
        audioPlayer.paused ? (this.play = false) : (this.play = true);
      }, 500);
    },
    doPlay(arg) {
      // Do not attempt playback when the ACW dialog was opened without a wav URL.
      if (arg && !this.hasAudioSource()) return;
      this.play = arg;
      if (arg) {
        this.$refs.audioPlayer.play();
        clearInterval(audioInterval);
        this.audioCurrentTime = "00:00";
        this.audioAllTime = "00:00";
        this.getAudioTime();
        this.setAudioInterval();
      } else {
        this.$refs.audioPlayer.pause();
      }
    },
    rewind() {
      if (!this.hasAudioSource()) return;
      let audioPlayer = document.getElementById("audioPlayer");
      var reckon = (this.audioAllDuration * this.audioTime - 500) / 100;
      if (reckon <= 0) {
        this.audioCurrentTime = "00:00";
        audioPlayer.currentTime = 0;
      } else {
        this.audioCurrentTime = realFormatSecond(reckon);
        audioPlayer.currentTime = parseInt(reckon);
      }
    },
    forward() {
      if (!this.hasAudioSource()) return;
      let audioPlayer = document.getElementById("audioPlayer");
      var reckon = realFormatSecond(
        (this.audioAllDuration * this.audioTime + 500) / 100
      );
      if (reckon >= this.audioAllTime) {
        this.audioCurrentTime = this.audioAllTime;
        audioPlayer.currentTime = 1;
      } else {
        this.audioCurrentTime = reckon;
        audioPlayer.currentTime = parseInt(
          (this.audioAllDuration * this.audioTime + 500) / 100
        );
      }
    },
    handleCommand(command) {
      this.multipleIndex = command;
      let audioPlayer = document.getElementById("audioPlayer");
      audioPlayer.playbackRate = command;
    },
    hasAudioSource() {
      const audioPlayer = this.$refs.audioPlayer || document.getElementById("audioPlayer");
      return !!(audioPlayer && audioPlayer.getAttribute("src"));
    },
    updateAudioPlayable() {
      // Keep the control button style in sync with records that do not have a playable wav URL.
      this.audioPlayable = this.hasAudioSource();
      if (!this.audioPlayable) {
        this.play = false;
      }
    },
    volumeControl(arg) {
      this.volumeCV = arg;
      if (arg) {
        this.volumeValue = this.volumeValueBack;
        let audioPlayer = document.getElementById("audioPlayer");
        audioPlayer.volume = this.volumeValue;
      } else {
        this.volumeValueBack = this.volumeValue;
        let audioPlayer = document.getElementById("audioPlayer");
        audioPlayer.volume = 0;
      }
    },
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 録音再生 - 音声ファイルが無い場合、callInfo.callTimeがあれば再生時間表示に使用
    getAudioTime() {
      var audioPlayer = document.getElementById("audioPlayer");
      const duration = audioPlayer.duration;
      const hasValidAudio = isFinite(duration) && duration > 0;
      if (!hasValidAudio && this.callInfo && this.callInfo.callTime) {
        this.audioAllTime = this.callInfo.callTime;
        this.audioCurrentTime = "00:00";
        this.audioAllDuration = 0;
        this.audioTime = 0;
        return;
      }
      if (!hasValidAudio) return;
      this.audioAllTime = realFormatSecond(duration);
      this.audioAllDuration = duration;
      this.audioCurrentTime = realFormatSecond(audioPlayer.currentTime);
      this.audioTime = (audioPlayer.currentTime / duration).toFixed(3) * 100;
    },
    onTimeChange(arg) {
      let audioPlayer = document.getElementById("audioPlayer");
      this.audioCurrentTime = realFormatSecond(
        (this.audioAllDuration * arg) / 100
      );
      audioPlayer.currentTime = parseInt((this.audioAllDuration * arg) / 100);
    },
    onVolumeChange(arg) {
      let audioPlayer = document.getElementById("audioPlayer");
      audioPlayer.volume = arg / 100;
    },
    /**
     * Handle Enter key press in the search input.
     * Navigate to the next keyword match position (same as clicking the down arrow button).
     */
    handleEnterKey() {
      if (this.multipleSelection.length > 0) {
        this.downSelect();
      }
    },
    downSelect() {
      for (let text of this.contenttextList) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      this.aiSummaryDisplay = this.aiSummaryDisplay.replace(
        RegExp("resultOff", "g"),
        "resultOn"
      );
      if (this.searchIndex >= this.multipleSelection.length) {
        this.searchIndex = 1;
      } else {
        this.searchIndex += 1;
      }
      const item = find(this.multipleSelection, {
        searchIndex: this.searchIndex,
      });
      if (item.isSummary) {
        let rowContentList = this.aiSummaryDisplay.split(this.search);
        let newContent = "";
        for (var m = 0; m < rowContentList.length; m++) {
          if (m == item.rowSearchIndex - 1) {
            newContent =
              newContent +
              rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
          } else {
            newContent = newContent + rowContentList[m];
          }
          if (m != rowContentList.length - 1) {
            newContent = newContent + this.search;
          }
        }
        this.aiSummaryDisplay = newContent;
        this.$nextTick(() => this.scrollToAiSummary());
        return;
      }
      let rowContentList = this.contenttextList[item.rowIndex].text.split(
        this.search
      );
      let newContent = "";
      for (var m = 0; m < rowContentList.length; m++) {
        if (m == item.rowSearchIndex - 1) {
          newContent =
            newContent +
            rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
        } else {
          newContent = newContent + rowContentList[m];
        }
        if (m != rowContentList.length - 1) {
          newContent = newContent + this.search;
        }
      }
      this.contenttextList[item.rowIndex].text = newContent;
      this.$nextTick(() => this.setCurrentRow(item.rowIndex));
    },
    upSelect() {
      for (let text of this.contenttextList) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      this.aiSummaryDisplay = this.aiSummaryDisplay.replace(
        RegExp("resultOff", "g"),
        "resultOn"
      );
      if (this.searchIndex == 1) {
        this.searchIndex = this.multipleSelection.length;
      } else {
        this.searchIndex -= 1;
      }
      const item = find(this.multipleSelection, {
        searchIndex: this.searchIndex,
      });
      if (item.isSummary) {
        let rowContentList = this.aiSummaryDisplay.split(this.search);
        let newContent = "";
        for (var m = 0; m < rowContentList.length; m++) {
          if (m == item.rowSearchIndex - 1) {
            newContent =
              newContent +
              rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
          } else {
            newContent = newContent + rowContentList[m];
          }
          if (m != rowContentList.length - 1) {
            newContent = newContent + this.search;
          }
        }
        this.aiSummaryDisplay = newContent;
        this.$nextTick(() => this.scrollToAiSummary());
        return;
      }
      let rowContentList = this.contenttextList[item.rowIndex].text.split(
        this.search
      );
      let newContent = "";
      for (var m = 0; m < rowContentList.length; m++) {
        if (m == item.rowSearchIndex - 1) {
          newContent =
            newContent +
            rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
        } else {
          newContent = newContent + rowContentList[m];
        }
        if (m != rowContentList.length - 1) {
          newContent = newContent + this.search;
        }
      }
      this.contenttextList[item.rowIndex].text = newContent;
      this.$nextTick(() => this.setCurrentRow(item.rowIndex));
    },
    setCurrentRow(index) {
      if (this.multipleSelection.length == 0) {
        return false;
      } else {
        // 基準は常に「全文テキスト」テーブル（multipleTextTable）
        const baseTable = this.$refs.multipleTextTable;
        if (!baseTable || !baseTable.$el) return;

        const baseRows = baseTable.$el.querySelectorAll(".el-table__body tr");
        if (!baseRows || !baseRows[index]) return;

        const targetTop = baseRows[index].getBoundingClientRect().top;
        const containerTop = baseTable.$el
          .querySelector(".el-table__body")
          .getBoundingClientRect().top;
        const scrollHeight = targetTop - containerTop;

        const setScroll = (tableRef) => {
          if (!tableRef || !tableRef.$el) return;
          const wrapper = tableRef.$el.querySelector(".el-table__body-wrapper");
          if (wrapper) wrapper.scrollTop = scrollHeight;
        };

        setScroll(this.$refs.multipleTextTable);
        setScroll(this.$refs.categoryTable);
        setScroll(this.$refs.mannerTable);
        setScroll(this.$refs.wowTable);
        setScroll(this.$refs.ngWordTable);
      }
    },
    scrollToAiSummary() {
      const el = this.$refs.aiSummaryContent;
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    },
    toggleSupportTime() {
      this.showSupportTime = !this.showSupportTime;
    },
    toggleAcwContent() {
      this.showAcwContent = !this.showAcwContent;
    },
    toggleCategory() {
      this.showCategory = !this.showCategory;
    },
    toggleNgcontent() {
      this.showNgcontent = !this.showNgcontent;
    },
    toggleAlerts() {
      this.showAlerts = !this.showAlerts;
    },
    toggleEscalation() {
      this.showEscalation = !this.showEscalation;
    },
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 録音再生表示 - 最初の1つの':'のみで分割（時刻01:05で分割されない）、text/callInfo未設定時はガード
    handleContent(text) {
      if (text == null || typeof text !== "string") return {};
      let firstColon = text.indexOf(":");
      if (firstColon === -1) return {};
      let userInfo = text.substring(0, firstColon).trim().replace(" ", "");
      let contentPart = text.substring(firstColon + 1).trim();
      let callInfo = this.callInfo || {};
      let toUserName = (
        callInfo.toUsername != null ? String(callInfo.toUsername) : ""
      )
        .trim()
        .replace(" ", "");
      let fromUserName = (
        callInfo.fromUsername != null ? String(callInfo.fromUsername) : ""
      )
        .trim()
        .replace(" ", "");
      let imageSrc = "";
      let userType = "";
      if (userInfo.indexOf(fromUserName) > -1) {
        imageSrc = callInfo.fromLogoUrl;
        userType = userInfo.replace(fromUserName, "").trim();
      } else if (userInfo.indexOf(toUserName) > -1) {
        imageSrc = callInfo.toLogoUrl;
        userType = userInfo.replace(toUserName, "").trim();
      } else if (userInfo.indexOf("（お問い合わせ者）") > -1) {
        imageSrc =
          callInfo.callType == "IN" ? callInfo.fromLogoUrl : callInfo.toLogoUrl;
        userType = "（お問い合わせ者）";
      } else {
        imageSrc =
          callInfo.callType == "IN" ? callInfo.toLogoUrl : callInfo.fromLogoUrl;
        userType =
          userInfo.indexOf("（") > -1
            ? userInfo.substr(userInfo.indexOf("（")).trim()
            : "";
      }
      return {
        imageSrc,
        userType,
        content: contentPart.replace(/\n/g, "<br/>"),
      };
    },
  },
  mounted() {
    this.showMask = this.value;
    this.volumeValue = 30;
    console.log("issueNumber", this.issueNumber);
    let audioPlayer = document.getElementById("audioPlayer");
    audioPlayer.volume = this.volumeValue / 100;

    // if (this.ngWordList !== undefined && this.ngWordList.length > 0) {
    this.$refs.ngWordTable.bodyWrapper.addEventListener("scroll", () => {
      const ngWordTablescroll = this.$refs.ngWordTable.$el.querySelector(
        ".el-table__body-wrapper"
      );

      const multipleTextTablescroll =
        this.$refs.multipleTextTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
      multipleTextTablescroll.scrollTop = ngWordTablescroll.scrollTop;

      const categoryTablescroll = this.$refs.categoryTable.$el.querySelector(
        ".el-table__body-wrapper"
      );
      categoryTablescroll.scrollTop = ngWordTablescroll.scrollTop;

      const mannerTablescroll = this.$refs.mannerTable.$el.querySelector(
        ".el-table__body-wrapper"
      );
      mannerTablescroll.scrollTop = ngWordTablescroll.scrollTop;

      const wowTablescroll = this.$refs.wowTable.$el.querySelector(
        ".el-table__body-wrapper"
      );
      wowTablescroll.scrollTop = ngWordTablescroll.scrollTop;
    });
    // } else if (this.mannersWowList !== undefined && this.mannersWowList.length > 0) {
    this.$refs.wowTable.bodyWrapper.addEventListener("scroll", () => {
      const wowTablescroll = this.$refs.wowTable.$el.querySelector(
        ".el-table__body-wrapper"
      );

      const multipleTextTablescroll =
        this.$refs.multipleTextTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
      multipleTextTablescroll.scrollTop = wowTablescroll.scrollTop;

      const categoryTablescroll = this.$refs.categoryTable.$el.querySelector(
        ".el-table__body-wrapper"
      );
      categoryTablescroll.scrollTop = wowTablescroll.scrollTop;

      const mannerTablescroll = this.$refs.mannerTable.$el.querySelector(
        ".el-table__body-wrapper"
      );
      mannerTablescroll.scrollTop = wowTablescroll.scrollTop;
    });
    this.$refs.mannerTable.bodyWrapper.addEventListener("scroll", () => {
      const mannerTablescroll = this.$refs.mannerTable.$el.querySelector(
        ".el-table__body-wrapper"
      );

      const multipleTextTablescroll =
        this.$refs.multipleTextTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
      multipleTextTablescroll.scrollTop = mannerTablescroll.scrollTop;

      const categoryTablescroll = this.$refs.categoryTable.$el.querySelector(
        ".el-table__body-wrapper"
      );
      categoryTablescroll.scrollTop = mannerTablescroll.scrollTop;
    });
    // } else if (this.categoryList !== undefined && this.categoryList.length > 0) {
    this.$refs.categoryTable.bodyWrapper.addEventListener("scroll", () => {
      const categoryTablescroll = this.$refs.categoryTable.$el.querySelector(
        ".el-table__body-wrapper"
      );

      const multipleTextTablescroll =
        this.$refs.multipleTextTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
      multipleTextTablescroll.scrollTop = categoryTablescroll.scrollTop;
    });
    // }
  },
  watch: {
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 録音再生 - ダイアログ表示時、callInfo.callTimeがあればaudioAllTime/audioCurrentTimeをセット
    value(newVal) {
      this.showMask = newVal;
      if (newVal) {
        this.updateAudioPlayable();
        if (this.callInfo && this.callInfo.callTime) {
          this.audioAllTime = this.callInfo.callTime;
          this.audioCurrentTime = "00:00";
        }
        this.aiSummaryDisplay = this.dialogAiContent || "";
        this.setAudioInterval();
      } else {
        clearInterval(audioInterval);
        this.multipleIndex = 1;
        let audioPlayer = document.getElementById("audioPlayer");
        audioPlayer.src = "";
        audioPlayer.playbackRate = 1;
        this.audioPlayable = false;
        this.audioCurrentTime = "00:00";
        this.audioAllTime = "00:00";
        this.search = "";
        this.oldSearch = "";
        this.searchIndex = 0;
        this.multipleSelection = [];
        this.aiSummaryDisplay = this.dialogAiContent || "";
      }
    },
    showMask(val) {
      this.$emit("input", val);
    },
    dialogAiContent() {
      if (!this.search) {
        this.aiSummaryDisplay = this.dialogAiContent || "";
      }
    },
    search() {
      if (this.oldSearch) {
        for (let text of this.contenttextList) {
          if (text.text.includes(this.oldSearch)) {
            text.text = text.text.replace(
              RegExp(
                '<span class="resultOn">' + this.oldSearch + "</span>",
                "g"
              ),
              this.oldSearch
            );
            text.text = text.text.replace(
              RegExp(
                '<span class="resultOff">' + this.oldSearch + "</span>",
                "g"
              ),
              this.oldSearch
            );
          }
        }
        this.aiSummaryDisplay = this.dialogAiContent || "";
      }
      this.searchIndex = 0;
      this.multipleSelection = [];
      if (this.search) {
        this.searchIndex = 1;
        let tmpmultipleSelection = [];
        let allCount = 0;
        for (var i = 0; i < this.contenttextList.length; i++) {
          let count = 0;
          if (this.contenttextList[i].text.includes(this.search)) {
            this.contenttextList[i].text = this.contenttextList[i].text.replace(
              RegExp(this.search, "g"),
              '<span class="resultOn">' + this.search + "</span>"
            );
            count = this.contenttextList[i].text.split(this.search).length - 1;
          }
          for (var j = 1; j <= count; j++) {
            let data = {
              rowIndex: i,
              rowSearchIndex: j,
              searchIndex: allCount + j,
            };
            tmpmultipleSelection.push(data);
          }
          allCount = allCount + count;
        }
        const aiPlain = this.dialogAiContent || "";
        if (aiPlain.includes(this.search)) {
          this.aiSummaryDisplay = aiPlain.replace(
            RegExp(this.search, "g"),
            '<span class="resultOn">' + this.search + "</span>"
          );
          let aiCount = aiPlain.split(this.search).length - 1;
          for (var k = 1; k <= aiCount; k++) {
            tmpmultipleSelection.push({
              isSummary: true,
              rowSearchIndex: k,
              searchIndex: allCount + k,
            });
          }
          allCount = allCount + aiCount;
        } else {
          this.aiSummaryDisplay = aiPlain;
        }
        this.multipleSelection = tmpmultipleSelection;
        if (this.multipleSelection.length > 0) {
          const item = find(this.multipleSelection, {
            searchIndex: this.searchIndex,
          });
          if (item.isSummary) {
            let rowContentList = this.aiSummaryDisplay.split(this.search);
            let newContent = "";
            for (var m = 0; m < rowContentList.length; m++) {
              if (m == item.rowSearchIndex - 1) {
                newContent =
                  newContent +
                  rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
              } else {
                newContent = newContent + rowContentList[m];
              }
              if (m != rowContentList.length - 1) {
                newContent = newContent + this.search;
              }
            }
            this.aiSummaryDisplay = newContent;
            this.$nextTick(() => this.scrollToAiSummary());
          } else {
            let rowContentList = this.contenttextList[item.rowIndex].text.split(
              this.search
            );
            let newContent = "";
            for (var m = 0; m < rowContentList.length; m++) {
              if (m == item.rowSearchIndex - 1) {
                newContent =
                  newContent +
                  rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
              } else {
                newContent = newContent + rowContentList[m];
              }
              if (m != rowContentList.length - 1) {
                newContent = newContent + this.search;
              }
            }
            this.contenttextList[item.rowIndex].text = newContent;

            this.setCurrentRow(item.rowIndex);
          }
        } else {
          this.searchIndex = 0;
        }
      } else {
        this.aiSummaryDisplay = this.dialogAiContent || "";
      }
      this.oldSearch = this.search;
    },
    multipleSelection(val) {
      if (val.length <= 1) {
        this.arrowFlg = false;
      } else {
        this.arrowFlg = true;
      }
    },
  },
  computed: {
    isVoiceBot() {
      const info = this.callInfo || {};
      return info.toPhoneNum === "-";
    },
    nextActionItems() {
      const text = this.nextActionContent || "";
      const lines = text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);

      // Only convert when every non-empty line follows the numbered-list format.
      const items = lines
        .map((line) => {
          const match = line.match(/^\d+[.)]\s*(.+)$/);
          return match ? match[1].trim() : "";
        })
        .filter(Boolean);

      return items.length === lines.length ? items : [];
    },
    supportDate() {
      return this.callInfo.callStartTime
        ? this.callInfo.callStartTime.substr(0, 10)
        : "";
    },
    startTime() {
      return this.callInfo.callStartTime
        ? this.callInfo.callStartTime.substr(11, 5)
        : "";
    },
    endTime() {
      return this.callInfo.callStartTime
        ? this.callInfo.callEndTime.substr(11, 5)
        : "";
    },
    callTime() {
      const duration = moment.duration(
        moment(this.callInfo.callEndTime, "YYYY-MM-DD HH:mm:ss").diff(
          moment(this.callInfo.callStartTime, "YYYY-MM-DD HH:mm:ss")
        )
      );
      let minutes = `${parseInt(duration.asMinutes())}`;
      let seconds = `${parseInt(duration.seconds())}`;
      return (
        " （" +
        (minutes > 0 ? `${minutes}分` : "") +
        (seconds > 0 ? `${seconds}秒` : "") +
        "）"
      );
    },
  },
};
function realFormatSecond(second) {
  var secondType = typeof second;
  if (secondType === "number" || secondType === "string") {
    second = parseInt(second);
    var mimute = Math.floor(second / 60);
    second = second - mimute * 60;
    var ret = ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2);
    if (ret == "aN:aN") {
      return "00:00";
    } else {
      return ret;
    }
  } else {
    return "00:00";
  }
}
</script>
<style scoped>
.el-avatar {
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.dialog-right-content >>> .el-table .cell {
  line-height: 20px;
  font-size: 13px;
}
.dialog-right-content >>> .el-table td,
.el-table th.is-leaf {
  border-bottom: rgba(0, 0, 0, 0) !important;
}
.dialog-right-content >>> .el-table td,
.el-table th {
  padding: 5px 0;
}
.backgroundDiv {
  /* width: 100%; */
  /* height: 260px; */
  position: absolute;
}
.backgroundDiv >>> .el-table__row {
  color: #606266;
}
.categoryDiv {
  /* width: 100%; */
  /* height: 260px; */
  position: absolute;
  background-color: transparent !important;
}
.categoryDiv >>> .el-table,
.el-table__expanded-cell {
  color: transparent !important;
  background-color: transparent !important;
}
.categoryDiv >>> .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
.categoryDiv >>> .el-table__row {
  background-color: transparent !important;
}
.mannersDiv {
  /* width: 100%; */
  /* height: 260px; */
  position: absolute;
  background-color: transparent !important;
}
.mannersDiv >>> .el-table,
.el-table__expanded-cell {
  color: transparent !important;
  background-color: transparent !important;
}
.mannersDiv >>> .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
.mannersDiv >>> .el-table__row {
  background-color: transparent !important;
}
.wowDiv {
  /* width: 100%; */
  /* height: 260px; */
  position: absolute;
  background-color: transparent !important;
}
.wowDiv >>> .el-table,
.el-table__expanded-cell {
  color: transparent !important;
  background-color: transparent !important;
}
.wowDiv >>> .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
.wowDiv >>> .el-table__row {
  background-color: transparent !important;
}
.ngWordDiv {
  /* width: 100%; */
  /* height: 260px; */
  position: absolute;
  background-color: transparent !important;
}
.ngWordDiv >>> .el-table,
.el-table__expanded-cell {
  color: transparent !important;
  background-color: transparent !important;
}
.ngWordDiv >>> .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
.ngWordDiv >>> .el-table__row {
  background-color: transparent !important;
}
.el-tag {
  border-width: 2px;
  margin-right: 10px;
  margin-bottom: 5px;
  line-height: 20px;
  height: 24px;
}
.dialog-right-content >>> .resultOn {
  background: yellow;
}
.dialog-right-content >>> .resultOff {
  background: greenyellow;
}
.dialog-right-content >>> .ngwordOType {
  color: #ffc000;
  font-weight: 1300;
}
.dialog-right-content >>> .ngwordQType {
  color: red;
  font-weight: 1300;
}
.dialog-right-content >>>.warningWordType {
  color:#ef5893;;
  font-weight: 1300;
}
.dialog-right-content >>> .categoryType {
  color: #26b1a0;
  font-weight: 1300;
}
.dialog-right-content >>> .ngMannerType {
  color: #ff9300;
  font-weight: 1300;
}
.dialog-right-content >>> .ngWowType {
  color: #00bfff;
  /* color: #67c23a; */
  font-weight: 1300;
}
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1200;
}
.audio-speed-dropdown >>> .el-dropdown-menu {
  margin: 26px 0 !important;
}
.dialog-container {
  min-width: 800px;
  height: calc(100% - 60px);
  /* background: #F2F2F2; */
  background: #ffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: relative;
  width: calc(100% - 150px);
  color: #606266;
}
.dialog-title {
  width: 100%;
  height: 40px;
  background-color: #1ab2f2;
  display: inline-flex;
}
.dialog-input {
  width: calc(100% - 365px);
  /* background-color: #5ED4FF; */
  display: inline-flex;
  height: 40px;
  padding-left: 20px;
}

.dialog-input >>> .search-nav-btn {
  width: 20px;
  min-width: 20px;
  height: 20px;
  padding: 0;
  margin-top: 10px; /* 40pxヘッダー内で中央寄せ */
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.gray-button {
  background-color: #909399 !important;
  border-color: #909399 !important;
  color: #fff !important;
}

.gray-button:hover,
.gray-button:focus {
  background-color: #7d7f82 !important;
  border-color: #7d7f82 !important;
}

.dialog-input >>> .search-nav-btn [class*="el-icon-"] {
  font-size: 12px;
  line-height: 1;
}
.dialog-title-text {
  float: left;
  height: 38px;
  width: 300px;
  /* padding-left: 10px;
  padding-right: 10px; */
}
.dialog-title-input {
  float: left;
  height: 40px;
  line-height: 36px;
  width: 635px;
  align-content: center;
  /* padding-left: 10px;
  padding-right: 10px; */
}
.dialog-title-close {
  float: left;
  height: 38px;
  width: 45px;
  text-align: center;
}
.dialog-title-text-span {
  color: #f2f2f2;
  /* font-family: arial; */
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  /* padding-left:10px; */
  /* display:block; */
}
.dialog-issue-number {
  color: #f2f2f2;
  /* font-family: arial; */
  font-size: 15px;
}
.dialog-title-input >>> .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  border: 2px solid #808080;
}
.dialog-tag {
  box-sizing: border-box;
  /* height: 150px; */
  /* margin: 0px 5px; */
  background-color: #fff;
  /* border: 1px solid #000; */
}
.dialog-category-title {
  box-sizing: border-box;
  height: 24px;
  margin-top: 10px;
  /* padding-left: 10px; */
  display: flex;
  justify-content: space-between;
}
.dialog-category-title-span {
  /* font-family: arial; */
  font-size: 14px;
  /* font-weight: bold; */
  /* color: black; */
}
.dialog-category {
  box-sizing: border-box;
  margin-top: 3px;
  /* padding-left: 10px; */
  /* min-height: 32px; */
  /* height: 40px; */
  /* border: 1px solid red; */
  /* overflow-y: hidden;
  overflow-x: hidden; */
}
.dialog-category >>> .el-tag {
  background-color: #fff;
  border-color: #fff;
  color: #fff;
  padding: 0 0px;
}
.dialog-category >>> .categoryType {
  background-color: #e9f5cf;
  border-color: #26b1a0;
  color: #26b1a0;
  /* border-style: solid;
  border-radius: 16px;
  border-width: 1px;
  display: inline-block;
  height: 28px;
  padding: 0 10px; */
}
.dialog-category >>> .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: auto;
}
.dialog-right-content-title {
  box-sizing: border-box;
  height: 25px;
  margin-top: 3px;
  padding-left: 10px;
}
.dialog-right-content-title-span {
  /* font-family: arial; */
  font-size: 14px;
  font-weight: bold;
  color: black;
}
.dialog-ngcontent {
  box-sizing: border-box;
  margin-top: 3px;
  padding-left: 10px;
  min-height: 32px;
  /* border: 1px solid red; */
}
.dialog-ngcontent >>> .el-tag {
  background-color: #fff;
  border-color: #fff;
  color: #fff;
  padding: 0 0px;
}
.dialog-ngcontent >>> .ngwordOType {
  background-color: #f8eabf;
  border-color: #ffc000;
  color: #ffc000;
  /* border-style: solid;
  border-radius: 16px;
  border-width: 1px;
  display: inline-block;
  height: 28px;
  padding: 0 10px; */
}
.dialog-ngcontent >>> .ngwordQType {
  background-color: #ff000026;
  border-color:  red;;
  color:  red;
  /* border-style: solid;
  border-radius: 16px;
  border-width: 1px;
  display: inline-block;
  height: 28px;
  padding: 0 10px; */
}
.dialog-ngcontent >>> .warningWordType {
  background-color: #ef58933b; 
  border-color:   #ef5893;
  color: #ef5893;
}
.dialog-ngcontent >>> .ngMannerType {
  background-color: #ff930030;
  border-color: #ff9300;
  color: #ff9300;
  /* border-style: solid;
  border-radius: 16px;
  border-width: 1px;
  display: inline-block;
  height: 28px;
  padding: 0 10px; */
}
.dialog-ngcontent >>> .ngWowType {
  /* background-color: #67c23a26;
  border-color: #67c23a;
  color: #67c23a; */
  background-color: #d3eef7;
  border-color: #00bfff;
  color: #00bfff;
  /* border-style: solid;
  border-radius: 16px;
  border-width: 1px;
  display: inline-block;
  height: 28px;
  padding: 0 10px; */
}
.dialog-ngcontent >>> .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: auto;
}
.dialog-left-content >>> .el-divider--horizontal {
  display: block;
  height: 1px;
  /* width: 96%; */
  margin: 10px 0 0 0;
}
/* .dialog-tag >>> .el-divider { } */
.dialog-right-content {
  background-color: #ffffff;
  box-sizing: border-box;
  /* height: 260px; */
  position: relative;
  width: calc(100% - 300px);
  height: 100%;
  /* margin: 0px 5px; */
  /* border: 1px solid #000; */
}
.dialog-footer {
  /* border: 1px solid #000; */
  height: 80px;
  background-color: #1ab2f2;
  display: flex;
}
.audio-control {
  /* float: left; */
  height: 78px;
  /* width: 594px; */
  /* border: 1px solid #000; */
  width: calc(50% - 40px);
  padding: 0px 20px;
}
.audio-control-top {
  height: 50px;
  /* width: 320px; */
  /* margin-left: 175px; */
  display: flex;
  justify-content: space-between;
  vertical-align: bottom;
}
.audio-control-top-play {
  float: left;
  height: 48px;
  width: 218px;
}
.audio-control-button {
  cursor: pointer;
}
.audio-control-button-disabled {
  cursor: not-allowed;
  opacity: 0.35;
  filter: grayscale(100%);
}
.popper__arrow {
  display: none;
}
.audio-control-top-speed {
  /* float: left; */
  height: 78px;
  width: 98px;
  /* margin-left: 4px; */
  align-content: center;
  padding-top: 6px;
}
.dropdown-link {
  cursor: pointer;
  color: white;
  display: block;
  width: 70px;
  /* margin-top: 10px;
  margin-left: 20px; */
  height: 24px;
  text-align: center;
  border: 4px solid white;
  border-radius: 6px;
  align-content: center;
}
.audio-control-bottom {
  height: 26px;
  width: 100%;
  /* margin-left: 10px; */
  /* border: 1px solid #000; */
}
.play-slider {
  /* float: left; */
  width: 100%;
  /* margin-left: 20px;
  margin-right: 20px; */
}
.audio-time {
  /* float: left; */
  font-size: 13px;
  color: white;
  height: 48px;
  align-content: end;
}
.play-slider >>> .el-slider__bar {
  background-color: #808080;
}
.play-slider >>> .el-slider__runway {
  margin-top: 5px;
}
.audio-volume {
  float: left;
  height: 78px;
  width: 200px;
  padding-top: 5px;
  /* border: 1px solid #000; */
}
.volume-slider {
  float: left;
  width: 120px;
  margin: 19px 10px;
}
.volume-slider >>> .el-slider__bar {
  background-color: #808080;
}
.left-content {
  width: 268px;
  padding-left: 16px;
  padding-right: 16px;
}
.dialog-content {
  display: inline-flex;
  width: 100%;
  height: calc(100% - 110px);
}
.dialog-left-content {
  height: 100%;
  border-right: solid 2px #e0dede;
  /* padding-top:10px; */
  overflow-y: auto;
}
.script-content-height {
  /* position: absolute;  */
  height: calc(100% - 155px);
  border: solid 1px #e0dede;
  border-radius: 8px;
}
/* 各栏の内框幅をカラム幅(40/30/30)に合わせる。全文栏の高亮叠层もここで一括指定 */
.wav-script-box .script-content-height {
  width: calc(40% - 16px);
}
.wav-script-box-ai .script-content-height {
  width: calc(30% - 16px);
}
.wav-script-box-next .script-content-height {
  width: calc(30% - 32px);
}
.audio-container {
  /* margin-left:300px; */
  /* margin:auto; */
  width: calc(100% - 300px);
  display: flex;
}
.dialog-issue-number {
  margin-left: 10px;
}
.user-info {
  display: flex;
  vertical-align: middle;
  line-height: 32px;
  padding-top: 10px;
  padding-left: 10px;
}
.user-info-margin-left {
  margin-left: 10px;
}
.content-title {
  line-height: 24px;
  padding: 10px 20px;
}
.content-title-text {
  height: 24px;
  overflow-y: auto;
  vertical-align: middle;
}
.title-jump-text {
  text-align: right;
  color: white;
  height: 40px;
  line-height: 40px;
  float: left;
  width: 80px;
}
.left-div-title {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  line-height: 24px;
}
.support-time {
  /* padding:0 10px; */
  line-height: 24px;
}
.left-content-small-text {
  padding-left: 10px;
  font-size: 12px;
  line-height: 20px;
}
.wav-content {
  display: flex;
  height: calc(100% - 110px);
}
.wav-image-box {
  width: calc(50% - 32px);
  padding: 0 16px;
}
.wav-script-box {
  width: calc(40% - 16px);
  padding: 0 0 0 16px;
}
.wav-script-box-ai {
  width: calc(30% - 16px);
  padding: 0 0 0 16px;
}
.wav-script-box-next {
  width: calc(30% - 16px);
  padding: 0 0 0 16px;
}
.wav-script-content {
  width: 100%;
}
.wav-title {
  padding-bottom: 10px;
  padding-left: 4px;
}
.wav-image {
  border: solid 1px #e0dede;
  border-radius: 8px;
  height: calc(100% - 45px);
  text-align: center;
  background: #ffffff;
  padding: 0 4px;
  position: relative;
}
.wav-script-title {
  padding-bottom: 10px;
  padding-left: 4px;
}
.detected-alerts {
  box-sizing: border-box;
  margin-top: 3px;
  padding-left: 10px;
  min-height: 32px;
  /* height: 40px; */
  /* border: 1px solid red; */
  /* overflow-y: hidden;
  overflow-x: hidden; */
}
.detected-alerts >>> .el-tag {
  background-color: #fff;
  border-color: #fff;
  color: #fff;
  padding: 0 0px;
}
.detected-alerts >>> .alert-sv {
  background-color: #e2d6ec;
  border-color: #7030a0;
  color: #7030a0;
}
.detected-alerts >>> .alert-ng {
  /* background-color: #fff2d3;
  border-color: #ffc000;
  color: #ffc000; */
  /* background-color: #fad9d89e;
  border-color: #fc7d78;
  color: #fc7d78; */
  /* border-color: #ffcdd2;
  color:#ffcdd2 */
  background-color: #ff000026;
  border-color:  red;;
  color:  red;
}
.detected-alerts >>> .alert-long-time {
  /* background-color: #eadcce;
  border-color: #996633; ;
  color: #996633; */
  background-color: #d5934f54;
  border-color: #d5934f;
  color: #d5934f;
}
.detected-alerts >>> .alert-warning-tag {
  background-color:#ef58933b;
  border-color: #ef5893;
  color: #ef5893;
}
.detected-alerts >>> .alert-acw-content {
  background-color: #80008024;
  border-color: purple;
  color: purple;
}
.el-tag-common {
  border-radius: 16px;
  border-width: 1px;
  font-size: 12px;
  border-style: solid;
  display: inline-block;
  height: 20px;
  padding: 0 10px;
}
.score-content {
  display: flex;
  justify-content: space-between;
}
.wav-from-avatar {
  position: absolute;
  top: 20%;
  left: 20px;
}
.wav-to-avatar {
  position: absolute;
  bottom: 30%;
  left: 20px;
}
.script-content-ai {
  padding-left: 10px;
  padding-right: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}
.script-content-next {
  padding-left: 10px;
  padding-right: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}
.next-action-list {
  /* margin: 0; */
  padding-left: 24px;
}
.next-action-list li {
  padding-left: 4px;
  margin-bottom: 6px;
  line-height: 1.6;
}
</style>